// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"21d12c19","489":"f55f987e","593":"fe46ddd7","870":"1e0b0fd0"}[chunkId] + ".chunk.css";
};